import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getBaseURL } from 'helpers';

const DataConfirmationModal = ({ show, onClose, message, btn1_text, btn2_text }) => {
    const handleOk = () => {
        onClose(true);
    };
    const handleCancel = () => {
        onClose(false);
    };

    return (
        <Modal show={show} onHide={handleCancel} centered>
            <Modal.Body
                style={{
                    backgroundImage: `url(${getBaseURL("/assets/icons/Reset-Password.png")})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '70%',
                    backgroundPosition: "19px"
                }}
                className="p-5 m-auto border-0">
                <div>
                    <div className="text-center fs-3">
                        <div className="fs-3 p-5">
                            {message}
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-center pt-3">
                    <button
                        type="button"
                        className="btn btn--primary btn-sm m-1 footer"
                        onClick={handleOk}
                    >
                        {btn1_text}
                    </button>
                    <button
                        type="button"
                        className="btn btn--primary btn-sm m-1 footer ms-2"
                        onClick={handleCancel}
                    >
                        {btn2_text}
                    </button>
                </div>
            </Modal.Body>

        </Modal>
    );
};
DataConfirmationModal.defaultProps = {
    message: 'Are you sure you want to save data',
    btn1_text: 'Ok',
    btn2_text: 'Cancel',
};

export default DataConfirmationModal;
